import * as React from 'react';
import { Dialog, DialogType, DialogFooter, IDialogContentProps } from '@fluentui/react/lib/Dialog';
import { Text } from '@fluentui/react';
import { PrimaryButton, DefaultButton } from '@fluentui/react/lib/Button';
import { ContextualMenu } from '@fluentui/react/lib/ContextualMenu';
import { Icon } from 'office-ui-fabric-react';

const dragOptions = {
  moveMenuItemText: 'Move',
  closeMenuItemText: 'Close',
  menu: ContextualMenu,
};
// const modalPropsStyles = { main: { minWidth: 900 } };

interface IErrorTemplateDialog {
  showDialog: boolean;
  toggleShowDialog: () => void;
  errorMsg: string;
  minWidth?: number;
  maxWidth?: number;
}

const ErrorTemplateDialog = (props: IErrorTemplateDialog) => {
  const modalProps = {
    isBlocking: true,
    // styles: modalPropsStyles,
    dragOptions: dragOptions,
  };

  const dialogContentProps: IDialogContentProps = {
    type: DialogType.largeHeader,
    title: (
      <div>
        <Icon iconName="StatusErrorFull" style={{ position: 'relative', top: '3px' }} /> Atención
      </div>
    ),
    styles: {
      header: {
        background: '#ff4848',
      },
      title: {
        color: 'white',
      },
      content: {
        borderTop: '4px solid #ff4848',
      },
    },
  };

  return (
    <>
      <Dialog
        hidden={!props.showDialog}
        onDismiss={props.toggleShowDialog}
        dialogContentProps={dialogContentProps}
        modalProps={modalProps}
        minWidth={props.minWidth ? props.minWidth : 400}
        className="ms-motion-scaleDownIn"
        // className={props.showDialog ? 'dialogVisible' : 'dialogHidden'}
      >
        <div className="mt-2">
          <Text variant="mediumPlus">{props.errorMsg}</Text>
        </div>
        <DialogFooter>
          <DefaultButton onClick={props.toggleShowDialog} text={'Listo'} />
        </DialogFooter>
      </Dialog>
    </>
  );
};

export default ErrorTemplateDialog;
